import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['revealer', 'alternate']
  static classes = ['hidden']

  static values = { id: String, hideButton: Boolean }

  get revealElement() {
    const toReveal = this.element.querySelector(`#${this.idValue}`)

    if (!toReveal) {
      throw new Error(`Cannot find element with DOM ID '${this.idValue}'. Please verify you have no typos`)
    }

    return toReveal
  }

  get revealElementVisible() {
    return !this.revealElement.classList.contains(this.hiddenClass)
  }

  revealButton() {
    return this.element.querySelector('[data-reveal-target]')
  }

  toggle() {
    if (this.revealElementVisible) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.revealerTarget.setAttribute('aria-expanded', 'true')
    this.revealElement.classList.remove(this.hiddenClass)
    if (this.hasAlternateTarget) {
      this.alternateTarget.classList.add(this.hiddenClass)
    }
    if (this.hideButtonValue) {
      this.revealButton().classList.add(this.hiddenClass)
    }
  }

  hide() {
    this.revealerTarget.setAttribute('aria-expanded', 'false')
    this.revealElement.classList.add(this.hiddenClass)
    if (this.hasAlternateTarget) {
      this.alternateTarget.classList.remove(this.hiddenClass)
    }
    if (this.hideButtonValue) {
      this.revealButton().classList.remove(this.hiddenClass)
    }
  }
}
